// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HGv8","signatureBlock":"Footer_signatureBlock__31cDg","signature":"Footer_signature__33Hlh"};